@if (performance) {
  <div class="button-with-dot">
    <!-- Show button when template exists or showreport already exists -->
    @if (hasShowreport() || hasActiveTemplate || isCheckingTemplate || performance.show.useLegacyShowreport) {
      <ion-button
        (click)="showShowreport()"
        [color]="isShowreportConcept() ? 'medium' : 'eventslight'"
        [fill]="hasShowreport() ? 'solid' : 'clear'"
        [disabled]="isCheckingTemplate"
        class="multiline-label"
        expand="block">
        @if (isCheckingTemplate) {
          <ion-spinner name="crescent" style="width: 16px; height: 16px; margin-right: 8px;"></ion-spinner>
        } @else if (isShowreportConcept()) {
          {{ 'performanceCard.showreportButton.concept' | translate }}
        } @else if (!hasShowreport()) {
          {{ 'performanceCard.showreportButton.empty' | translate }}
        } @else {
          {{ 'performanceCard.showreportButton.view' | translate }}
        }
      </ion-button>
    }
    <!-- Show disabled button with message when no template exists -->
    @if (!hasShowreport() && !hasActiveTemplate && !isCheckingTemplate && !performance.show.useLegacyShowreport) {
      <ion-button
        (click)="showShowreport()"
        color="medium"
        fill="clear"
        expand="block">
        <ion-icon name="alert-circle-outline" slot="start" />
        {{ 'performanceCard.showreportButton.noTemplate' | translate }}
      </ion-button>
    }
    @if (hasUnseenChange) {
      <span class="change-dot" aria-label="Gewijzigd sinds je het laatst zag"></span>
    }
  </div>
  <span class="stagemanager-name crew-name"
        [class.crew-name--unassigned]="!performance.showreport">
    {{ performance | getUserFullNameFromPerformanceWithRole: CrewRole.stagemanager }}
  </span>
}
